import * as React from 'react';
import { GoogleAdsParsingStatusGq } from '../../../../graphql/projects/models/GoogleAdsParsingStatusGq';
import { GoogleAdsRequestAnalysisGq } from '../../../../graphql/projects/models/GoogleAdsRequestAnalysisGq';
import VoxelChip from '../../../../components/voxel/Chips/VoxelChip';

export interface ProjectStatusKeywordRequestChipProps {
  requestAnalysis: GoogleAdsRequestAnalysisGq;
  hideCompleted?: boolean;
}

const ProjectStatusKeywordRequestChip: React.FC<ProjectStatusKeywordRequestChipProps> = ({
  requestAnalysis,
  hideCompleted,
}) => {
  const countLeft = requestAnalysis.processingCalls + requestAnalysis.queuedCalls;
  const countTotal = requestAnalysis.processingCalls + requestAnalysis.totalCalls;
  const counter = ` (${countTotal - countLeft}/${countTotal})`;
  if (requestAnalysis.request.paused) {
    return <VoxelChip size="xs" color="neutral" title={`Paused` + counter} />;
  }

  // Pre processing scenarios
  if (
    requestAnalysis.request.parsingStatus === GoogleAdsParsingStatusGq.PROCESSING ||
    requestAnalysis.comboTagsSettingUp ||
    requestAnalysis.comboSettingUp
  ) {
    return <VoxelChip size="xs" color="info" title={'Processing' + counter} />;
  }

  if (requestAnalysis.request.parsingStatus === GoogleAdsParsingStatusGq.FAILED) {
    return <VoxelChip size="xs" color="error" title={'Setup failed'} />;
  }

  // Google suggest scenarios
  if (
    !!requestAnalysis.suggestSeedsCronJobFailed &&
    requestAnalysis.suggestSeedsCronJobFailed + requestAnalysis.suggestSeedsCompleted ==
    requestAnalysis.suggestSeedsTotal
  ) {
    return <VoxelChip size="xs" color="error" title={'Setup failed'} />;
  }

  if (
    !!requestAnalysis.suggestSeedsPubSubPossibleFail &&
    requestAnalysis.suggestSeedsCronJobFailed + requestAnalysis.suggestSeedsCompleted <
    requestAnalysis.suggestSeedsTotal
  ) {
    return <VoxelChip size="xs" color="warning" title="Setup failed, but retrying" />;
  }

  if (
    requestAnalysis.suggestSeedsCompleted < requestAnalysis.suggestSeedsTotal ||
    requestAnalysis.suggestKeywordsBatching
  ) {
    return <VoxelChip size="xs" color="info" title={'Processing' + counter} />;
  }

  // Completed scenarios
  if (requestAnalysis.completedCalls === requestAnalysis.totalCalls) {
    if (hideCompleted) return null;
    return <VoxelChip size="xs" color="success" title="Done" />;
  }

  if (
    requestAnalysis.completedCalls > 0 &&
    requestAnalysis.completedCalls + requestAnalysis.failedCalls === requestAnalysis.totalCalls
  ) {
    return <VoxelChip size="xs" color="warning" title="Partially failed" />;
  }

  if (requestAnalysis.failedCalls === requestAnalysis.totalCalls) {
    return <VoxelChip size="xs" color="warning" title="Failed" />;
  }

  if (requestAnalysis.processingCalls || requestAnalysis.queuedCalls) {
    return <VoxelChip size="xs" color="info" title={'Processing' + counter} />;
  }

  return <>-</>;
};

export default ProjectStatusKeywordRequestChip;
